const customerSelectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  setDefaultButton: 'button[data-set-default-address]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (this.elements.length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
    this._saveAddressToAttrubutes();
  }

  async _saveAddressToAttrubutes() {
    const addr = window.customerDefaultAddress || {};

    const body = JSON.stringify({
      attributes: {
        customer_address1: addr.address1 || '',
        customer_address2: addr.address2 || '',
        customer_city: addr.city || '',
        customer_company: addr.company || '',
        customer_first_name: addr.first_name || '',
        customer_last_name: addr.last_name || '',
        customer_name: addr.name || '',
        customer_phone: addr.phone || '',
        customer_country: addr.country || '',
        customer_country_code: addr.country_code || '',
        customer_country_name: addr.country_name || '',
        customer_customer_id: addr.customer_id || '',
        customer_province: addr.province || '',
        customer_province_code: addr.province_code || '',
        customer_zip: addr.zip || '',
      },
    });

    await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'set-location', cartData: parsedState });
        console.log('cartData', parsedState);
      })
      .catch((error) => {
        console.error('Error updating cart attributes:', error);
      });
  }

  _getElements() {
    const containers = document.querySelectorAll(customerSelectors.customerAddresses);
    const containersArray = Array.from(containers, (container) => {
      const editModalButtons = container.querySelectorAll('modal-opener');

      const modal_elements = [];
      editModalButtons.forEach((editModalButton) => {
        const editModalId = editModalButton.getAttribute('data-modal');
        const modal = document.querySelector(editModalId);
        modal_elements.push(modal);
      });

      // Flatten country selects from all related modals into a single array of elements
      const countrySelects = modal_elements.reduce((acc, modal) => {
        if (!modal) return acc;
        const nodeList = modal.querySelectorAll(customerSelectors.addressCountrySelect);
        return acc.concat(Array.from(nodeList));
      }, []);

      return {
        container,
        locationPosition: container.dataset.locationPosition,
        addressContainer: container.querySelectorAll(customerSelectors.addressContainer),
        toggleButtons: container.querySelectorAll(customerSelectors.toggleAddressButton),
        cancelButtons: container.querySelectorAll(customerSelectors.cancelAddressButton),
        deleteButtons: container.querySelectorAll(customerSelectors.deleteAddressButton),
        countrySelects,
        setDefaultButton: container.querySelector(customerSelectors.setDefaultButton),
      };
    });

    console.log('CustomerAddresses elements', containersArray);

    return containersArray;
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      this.elements.forEach((element) => {
        const countrySelect = 'AddressCountryNew-' + element.locationPosition;
        const provinceSelect = 'AddressProvinceNew-' + element.locationPosition;
        const provinceContainer = 'AddressProvinceContainerNew-' + element.locationPosition;

        new Shopify.CountryProvinceSelector(countrySelect, provinceSelect, {
          hideElement: provinceContainer,
        });

        // Ensure province required reflects current visibility for "New" address form
        this._updateProvinceRequired(element);
        const newCountryEl = document.getElementById(countrySelect);
        newCountryEl &&
          newCountryEl.addEventListener('change', () => {
            // After provinces update, sync required state
            this._updateProvinceRequired(element);
          });

        element.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(
            `AddressCountry_${formId}-${element.locationPosition}`,
            `AddressProvince_${formId}-${element.locationPosition}`,
            {
              hideElement: `AddressProvinceContainer_${formId}-${element.locationPosition}`,
            }
          );

          // Initial and on-change sync for existing address edit forms
          this._updateProvinceRequired(element);
          select.addEventListener('change', () => {
            this._updateProvinceRequired(element);
          });
        });
      });
    }
  }

  _updateProvinceRequired(element) {
    // Handle "New" address form
    this._setRequiredByContainer(
      `AddressProvinceNew-${element.locationPosition}`,
      `AddressProvinceContainerNew-${element.locationPosition}`
    );

    // Handle existing address edit forms
    element.countrySelects.forEach((select) => {
      const formId = select.dataset.formId;
      this._setRequiredByContainer(
        `AddressProvince_${formId}-${element.locationPosition}`,
        `AddressProvinceContainer_${formId}-${element.locationPosition}`
      );
    });
  }

  _setRequiredByContainer(provinceId, containerId) {
    const provinceEl = document.getElementById(provinceId);
    const containerEl = document.getElementById(containerId);
    if (!provinceEl || !containerEl) return;
    const isVisible = getComputedStyle(containerEl).display !== 'none';
    if (isVisible && provinceEl.options && provinceEl.options.length > 0) {
      provinceEl.setAttribute('required', 'required');
    } else {
      provinceEl.removeAttribute('required');
    }
  }

  _setupEventListeners() {
    this.elements.forEach((element) => {
      element.toggleButtons.forEach((element) => {
        element.addEventListener('click', this._handleAddEditButtonClick);
      });
    });
    this.elements.forEach((element) => {
      element.cancelButtons.forEach((element) => {
        element.addEventListener('click', this._handleCancelButtonClick);
      });
    });
    this.elements.forEach((element) => {
      element.deleteButtons.forEach((element) => {
        element.addEventListener('click', this._handleDeleteButtonClick);
      });
    });
    this.elements.forEach((element) => {
      if (element.setDefaultButton) {
        element.setDefaultButton.addEventListener('click', this._handleSetDefaultButtonClick.bind(this, element));
      }
    });
  }

  _handleSetDefaultButtonClick = (element, { currentTarget }) => {
    const modal = document.querySelector(currentTarget.dataset.modal);
    const modalForm = modal.querySelector('form');
    const modalCheckbox = modal.querySelector('input[name="address[default]"]');
    const modalSubmitButton = modal.querySelector('button[type="submit"]');
    console.log('Setting default address', modal);
    console.log('Modal form', modalForm);
    console.log('Modal checkbox', modalCheckbox);
    if (modal && modalForm && modalCheckbox) {
      // modal.show();
      modalCheckbox.checked = true;
      // modalForm.submit();
      modalSubmitButton.click();
    }
  };

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget.closest(customerSelectors.addressContainer).querySelector(`[${attributes.expanded}]`)
    );
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // Prevent double confirmation dialogs
    if (window.isShowingDeleteConfirmation) {
      return;
    }

    window.isShowingDeleteConfirmation = true;

    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: {
          _method: 'delete',
          return_to: window.location.pathname + window.location.search,
        },
      });
    }

    window.isShowingDeleteConfirmation = false;
  };
}
